var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled / Dumbbell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_COLOR",
    d: "M3.25 4.5H1.75C1.33438 4.5 1 4.83437 1 5.25V8.5H0.25C0.1125 8.5 0 8.6125 0 8.75V10.25C0 10.3875 0.1125 10.5 0.25 10.5H1V13.75C1 14.1656 1.33438 14.5 1.75 14.5H3.25C3.66563 14.5 4 14.1656 4 13.75V5.25C4 4.83437 3.66563 4.5 3.25 4.5ZM19.75 8.5H19V5.25C19 4.83437 18.6656 4.5 18.25 4.5H16.75C16.3344 4.5 16 4.83437 16 5.25V13.75C16 14.1656 16.3344 14.5 16.75 14.5H18.25C18.6656 14.5 19 14.1656 19 13.75V10.5H19.75C19.8875 10.5 20 10.3875 20 10.25V8.75C20 8.6125 19.8875 8.5 19.75 8.5ZM14.25 2.5H12.75C12.3344 2.5 12 2.83437 12 3.25V8.5H8V3.25C8 2.83437 7.66563 2.5 7.25 2.5H5.75C5.33437 2.5 5 2.83437 5 3.25V15.75C5 16.1656 5.33437 16.5 5.75 16.5H7.25C7.66563 16.5 8 16.1656 8 15.75V10.5H12V15.75C12 16.1656 12.3344 16.5 12.75 16.5H14.25C14.6656 16.5 15 16.1656 15 15.75V3.25C15 2.83437 14.6656 2.5 14.25 2.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.388c257a67ddb378de7ffe910efc79cd.svg";
export { ForwardRef as ReactComponent };